var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.open
    ? _c(
        "div",
        { staticClass: "modal", class: _vm.M_mode === "video" ? "wider" : "" },
        [
          _c("div", {
            ref: "backdrop",
            staticClass: "modal-backdrop",
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.closeHandler(true)
              }
            }
          }),
          _vm._v(" "),
          _c("div", { ref: "wrapper", staticClass: "modal-wrapper" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("i", {
                staticClass: "icon icon-close",
                on: {
                  click: function($event) {
                    return _vm.closeHandler(true)
                  }
                }
              }),
              _vm._v(" "),
              _c("h3", [_vm._v(_vm._s(_vm.title))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c(
                "div",
                { staticClass: "body-wrapper" },
                [
                  _vm.M_mode === "login"
                    ? [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.phone,
                              expression: "phone"
                            }
                          ],
                          staticClass: "input",
                          attrs: {
                            type: "number",
                            placeholder: "用户名/电话号码"
                          },
                          domProps: { value: _vm.phone },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.phone = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password,
                              expression: "password"
                            }
                          ],
                          staticClass: "input",
                          attrs: { type: "password", placeholder: "密码" },
                          domProps: { value: _vm.password },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.login()
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.password = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "button",
                            on: {
                              click: function($event) {
                                return _vm.login()
                              }
                            }
                          },
                          [_vm._v("立即登录")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "buttons" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn",
                              on: {
                                click: function($event) {
                                  _vm.M_mode = "register"
                                }
                              }
                            },
                            [_vm._v("\n              新用户注册\n            ")]
                          )
                        ])
                      ]
                    : _vm.M_mode === "register"
                    ? [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.phone,
                              expression: "phone"
                            }
                          ],
                          staticClass: "input",
                          attrs: {
                            type: "number",
                            placeholder: "用户名/电话号码"
                          },
                          domProps: { value: _vm.phone },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.phone = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "validation input-group",
                            class: { active: _vm.phoneValid && _vm.canSend }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.verifyCode,
                                  expression: "verifyCode"
                                }
                              ],
                              staticClass: "verify input",
                              attrs: { type: "number" },
                              domProps: { value: _vm.verifyCode },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.verifyCode = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "span",
                                on: { click: _vm.sendVerifyCode }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.canSend,
                                        expression: "canSend"
                                      }
                                    ]
                                  },
                                  [_vm._v("发送验证码")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.canSend,
                                        expression: "!canSend"
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.resendCodeTime) + "秒后发送"
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password,
                              expression: "password"
                            }
                          ],
                          staticClass: "input",
                          attrs: { type: "password", placeholder: "设置密码" },
                          domProps: { value: _vm.password },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.password = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password2,
                              expression: "password2"
                            }
                          ],
                          staticClass: "input",
                          attrs: { type: "password", placeholder: "确认密码" },
                          domProps: { value: _vm.password2 },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.password2 = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.nickname,
                              expression: "nickname"
                            }
                          ],
                          staticClass: "input",
                          attrs: { type: "text", placeholder: "用户昵称" },
                          domProps: { value: _vm.nickname },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.nickname = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.referee,
                              expression: "referee"
                            }
                          ],
                          staticClass: "input",
                          attrs: {
                            type: "text",
                            placeholder: "推荐码（选填）"
                          },
                          domProps: { value: _vm.referee },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.referee = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "button",
                            attrs: { disabled: !_vm.canRegister },
                            on: {
                              click: function($event) {
                                return _vm.register()
                              }
                            }
                          },
                          [_vm._v("\n            立即注册\n          ")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "buttons" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn",
                              on: {
                                click: function($event) {
                                  _vm.M_mode = "login"
                                }
                              }
                            },
                            [_vm._v("返回登录")]
                          )
                        ])
                      ]
                    : _vm.M_mode === "userInfo"
                    ? [
                        _c("div", { staticClass: "row" }, [
                          _c("span", { staticClass: "left" }, [_vm._v("头像")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "right avatar" }, [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.userAvatar || _vm.useTextImg,
                                    expression: "!userAvatar || useTextImg"
                                  }
                                ]
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.userInfo.nickname
                                      .substr(0, 1)
                                      .toUpperCase()
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.userAvatar,
                                  expression: "userAvatar"
                                }
                              ],
                              attrs: {
                                onerror: (_vm.useTextImg = true),
                                src: _vm.userAvatar,
                                alt: "用户头像"
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("span", { staticClass: "left" }, [
                            _vm._v(
                              _vm._s(_vm.userInfo.name ? "真实姓名" : "昵称")
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "right" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.userInfo.name || _vm.userInfo.nickname
                                )
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("span", { staticClass: "left" }, [
                            _vm._v("电话号码")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "right" }, [
                            _c("span", [_vm._v(_vm._s(_vm.userInfo.phone))])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("span", { staticClass: "left" }, [_vm._v("公司")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "right" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.userInfo.company || ""))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("span", { staticClass: "left" }, [
                            _vm._v("认证状态")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "right" }, [
                            _c("span", [_vm._v(_vm._s(_vm.authStatus))])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("span", { staticClass: "left" }, [
                            _vm._v("我的推荐码")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "right" }, [
                            _c("span", [_vm._v(_vm._s(_vm.userInfo.refCode))])
                          ])
                        ])
                      ]
                    : [
                        _c("video", {
                          attrs: {
                            src: _vm.videoSrc,
                            controls: "",
                            autoplay: "",
                            width: "880",
                            height: "490"
                          }
                        })
                      ]
                ],
                2
              )
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-0eaeaf66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0eaeaf66","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/modal.vue
// module id = null
// module chunks = 